import {
  Box,
  Button,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  useColorModeValue,
  useDisclosure
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { InputSearch } from "../../../components/Atomos/Form/Elements/InputSearch";
import { DesktopMenuList } from "./DesktopMenuList";

type Prop = {
  children: React.ReactNode;
  triggerSize?: "xs" | "sm" | "md" | "lg";
};

export const DesktopMenu = ({ children, triggerSize = "md" }: Prop) => {
  const [search, setSearch] = useState<string>("");
  const { onOpen, onClose, isOpen } = useDisclosure();
  const initialFocusRef = useRef<HTMLInputElement>(null);

  const color = useColorModeValue("gray.800", "white");

  return (
    <Popover
      placement="bottom-start"
      initialFocusRef={initialFocusRef}      
      variant="responsive"
      gutter={12}
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}      
    >
      <PopoverTrigger>
        <Button
          size={triggerSize}
          p={0}
          variant="unstyled"
          _focus={{ boxShadow: "none" }}
          aria-label={`Menu button`}
        >
          {children}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        w="750px"
        px={6}        
        py={4}
        boxShadow="lg"
        color={color}
        bgColor={useColorModeValue("white", "gray.900")}
      >
        <PopoverBody>
          <Box maxW="335px">
            <InputSearch
              borderRadius="md"
              size="sm"
              timer={0}
              color="secondary"
              onChangeValue={setSearch}
              ref={initialFocusRef}
            />
          </Box>
          <DesktopMenuList search={search} onRedirect={onClose} />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
